var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12",
    "data-name": "Group 12",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.154,
    height: 31,
    viewBox: "0 0 38.154 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "twitter-2",
    "data-name": "twitter",
    d: "M38.154,51.67a16.308,16.308,0,0,1-4.507,1.235,7.778,7.778,0,0,0,3.441-4.323,15.632,15.632,0,0,1-4.96,1.893A7.821,7.821,0,0,0,18.6,55.824a8.054,8.054,0,0,0,.181,1.784A22.14,22.14,0,0,1,2.656,49.426,7.824,7.824,0,0,0,5.06,59.88a7.725,7.725,0,0,1-3.534-.963V59a7.858,7.858,0,0,0,6.267,7.686,7.807,7.807,0,0,1-2.051.258,6.915,6.915,0,0,1-1.481-.134,7.9,7.9,0,0,0,7.309,5.449,15.717,15.717,0,0,1-9.7,3.336A14.648,14.648,0,0,1,0,75.49,22.021,22.021,0,0,0,12,79c14.394,0,22.263-11.923,22.263-22.258,0-.346-.012-.68-.029-1.011A15.6,15.6,0,0,0,38.154,51.67Z",
    transform: "translate(0 -48)",
    fill: "#1e97ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon_twitter.40897f969c92d7f5c4ae867201a7d0d8.svg";
export { ForwardRef as ReactComponent };